var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
OCS.Viewer.Functions.define_layer_group = function (in_implements, in_extends, options) {
    var extend = OCS.Viewer.Classes.LayerGroup;
    var implements = [];
    if (options) {
        if (options.has_legend) {
            implements.combine([new Class(OCS.Viewer.Interfaces.LayerGroupLegend)]);
        }

        // This means we are building a dynamic group for the initalization of a new group
        if (!options.static && !options.end_epoch_time && !options.start_epoch_time) {
            implements.combine([new Class(OCS.Viewer.Interfaces.LayerGroupTime)]);
        }
        if (options.dataset && OCS.Datasets[options.dataset]) {
            var dataset = OCS.Datasets[options.dataset];
            var datatype_interfacename = "LayerGroup" + dataset.get_datatype();
            if (OCS.Viewer.Interfaces[datatype_interfacename]) {
                implements.combine([new Class(OCS.Viewer.Interfaces[datatype_interfacename])]);
            }
        }
        if(options.background_draw) {
            implements.combine([new Class(OCS.Viewer.Interfaces.LayerGroupBackground)]);
        }
    }
    if (in_implements && in_implements.length) {
        implements.combine(in_implements);
    }

    if (in_extends) {
        extend = in_extends;
    }
    return new Class({
        Extends: extend,
        Implements: implements,
        class_name: "AbstractLayerGroup",
        debug: false,
        options: {
            init_start_timestamp_epoch: 0,
            init_end_timestamp_epoch: 0,
            layer_class: "",
            layer_name: '',
            layer_short_name: '',
            layer_style_ops: {},
            layer_source_ops: {
                init: {
                },
                metadata: {
                    variables: []
                }
            },
            static: false,
            visible: false
        }
    });
};

